/**
 * Sport glyph for Global Sport Mode cards.
 * Pickleball: paddle + perforated ball (colored version of the product icon).
 * Other sports: registry emoji (e.g. badminton 🏸).
 */
export default function SportGlyph({ glyph, emoji, className, size = 36 }) {
  if (glyph === "pickleball") {
    return (
      <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 64 64"
        aria-hidden
        focusable="false"
      >
        {/* Whole mark rotated 90° clockwise */}
        <g transform="rotate(90 32 32)">
          {/* Paddle — rounded rectangular face, matching reference angle */}
          <g transform="rotate(-38 36 30)">
            <rect x="18" y="4" width="30" height="34" rx="7" ry="7" fill="#2F6FED" />
            <rect
              x="18"
              y="4"
              width="30"
              height="34"
              rx="7"
              ry="7"
              fill="none"
              stroke="#1A1A1A"
              strokeWidth="3.2"
            />
            <rect
              x="22"
              y="8"
              width="14"
              height="22"
              rx="4"
              fill="rgba(255,255,255,0.18)"
            />
            <path d="M29 36 L35 36 L37 42 L27 42 Z" fill="#1A1A1A" />
            <rect x="27.5" y="41" width="9" height="18" rx="2.5" fill="#2A2A2A" />
            <rect x="26.5" y="56" width="11" height="4.5" rx="1.5" fill="#111" />
            <path
              d="M28.5 46h7M28.5 50h7M28.5 54h7"
              stroke="rgba(255,255,255,0.12)"
              strokeWidth="1.2"
              strokeLinecap="round"
            />
          </g>

          {/* Ball near paddle face (TT-style placement) */}
          <circle cx="20" cy="22" r="11.5" fill="#F5D000" />
          <circle
            cx="20"
            cy="22"
            r="11.5"
            fill="none"
            stroke="#C9A800"
            strokeWidth="1.2"
          />
          <circle cx="15.5" cy="17.5" r="1.7" fill="#fff" />
          <circle cx="21.5" cy="16" r="1.7" fill="#fff" />
          <circle cx="26" cy="19.5" r="1.7" fill="#fff" />
          <circle cx="14.5" cy="23" r="1.7" fill="#fff" />
          <circle cx="20" cy="22.5" r="1.7" fill="#fff" />
          <circle cx="25.5" cy="25" r="1.7" fill="#fff" />
          <circle cx="17" cy="28.5" r="1.55" fill="#fff" />
          <circle cx="22.5" cy="29.5" r="1.55" fill="#fff" />
          <path
            d="M13 19c3.5-4 10-4 14 0"
            fill="none"
            stroke="rgba(255,255,255,0.45)"
            strokeWidth="1.4"
            strokeLinecap="round"
          />
        </g>
      </svg>
    );
  }

  const fontSize = typeof size === "number" ? `${Math.round(size * 0.92)}px` : undefined;

  return (
    <span
      className={className}
      aria-hidden
      style={fontSize ? { fontSize, lineHeight: 1, display: "inline-block" } : undefined}
    >
      {emoji || "🏸"}
    </span>
  );
}
